import { PaymentTypeTypes } from "../../AdditionalPaymentsPage.types";

export const isBonusPayment = (type: string) => type === PaymentTypeTypes.BONUS;
export const isSeverancePayment = (type: string) =>
  type === PaymentTypeTypes.SEVERANCE;
export const isSupplementalPayment = (type: string) =>
  type === PaymentTypeTypes.SUPPLEMENTAL;
export const isCommissionPayment = (type: string) =>
  type === PaymentTypeTypes.COMMISSION;

export const renderPaymentMethodInput = (type: string) =>
  isBonusPayment(type) || isSupplementalPayment(type);
export const renderApplicableWorkPeriodInput = (type: string) =>
  isBonusPayment(type) ||
  isCommissionPayment(type) ||
  isSupplementalPayment(type);
export const renderTaxMethodInput = (type: string) =>
  isBonusPayment(type) || isCommissionPayment(type);
export const renderTaxesAndDeductionsSection = (type: string) =>
  isBonusPayment(type) ||
  isCommissionPayment(type) ||
  isSupplementalPayment(type);

/**
 * Validates if a payment date is valid based on business rules:
 * - Must not be a weekend (Saturday/Sunday)
 * - Must be on or after the earliest pay date
 * - For severance payments, must be after the termination date
 *
 * @param date - The date string to validate (MM/DD/YYYY format)
 * @param earliestPayDate - The earliest allowed payment date
 * @param paymentType - The type of payment (e.g., severance, bonus)
 * @param terminationDate - The termination date (required for severance payments)
 * @returns true if the date is valid, false otherwise
 */
export const isValidPaymentDate = (
  date: string,
  earliestPayDate: Date,
  paymentType: string,
  terminationDate?: Date
): boolean => {
  if (!date) {
    return true; // Allow empty dates (handled by required validation)
  }

  const selectedDate = new Date(date);
  const dayOfWeek = selectedDate.getDay();
  const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;

  // Block weekends
  if (isWeekend) {
    return false;
  }

  // Block dates before earliest pay date
  if (earliestPayDate && selectedDate < earliestPayDate) {
    return false;
  }

  // For severance payments, block dates not after termination date
  if (isSeverancePayment(paymentType) && terminationDate) {
    if (selectedDate <= terminationDate) {
      return false;
    }
  }

  return true;
};
